var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"page-"+_vm.get_router}},[_c('keep-alive',[(!_vm.$route.meta.notKeepAlive)?_c('router-view'):_vm._e()],1)],1),_c('transition',{attrs:{"name":"page-"+_vm.get_router}},[(_vm.$route.meta.notKeepAlive)?_c('router-view'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }